module.exports = __webpack_public_path__ + "static/media/24-2.4d56fd97.mp3";